import { toBRL } from "@/utils/formatters/formatCurrency";
import styles from "./styles.module.scss";

interface StorePriceProps {
  originalAmount: number;
  finalAmount: number;
  size?: "regular" | "large";
}

export function StorePrice({ originalAmount, finalAmount, size = "regular" }: StorePriceProps) {
  const discount = originalAmount > finalAmount && originalAmount > 0 ? Math.round((1 - finalAmount / originalAmount) * 100) : 0;

  return (
    <div className={`${styles.price} ${size === "large" ? styles.large : ""}`}>
      {discount > 0 && (
        <div className={styles.was}>
          <del aria-label={`De ${toBRL(originalAmount)}`}>{toBRL(originalAmount)}</del>
          <span className={styles.badge}>{discount}% OFF</span>
        </div>
      )}
      <strong>{toBRL(finalAmount)}</strong>
    </div>
  );
}
